export const SET_USERS_POOL = '[Admin App] Set users pool';
export const SET_USERS_PERSONAL_LIST = '[Admin App] Set users personal list';

export function setUsersPool(payload) {
    return {
      type: SET_USERS_POOL,
      payload: payload
    }
  }

  export function setUsersPersonalList(payload) {
    return {
      type: SET_USERS_PERSONAL_LIST,
      payload: payload
    }
  }